module.exports = __webpack_public_path__ + "img/employee.345e6ff5.svg";